export const acceptanceDateUpdateCodes = {
  allDesksUniquePeriods: 1, // когда все столы имеют уникальные периоды
  desksBusy: 2, // некоторые столы заняты
  outOfAcceptancePeriod: 3, // некоторые столы выпадают за пределы периода приёмки
  roomDateShift: 4, // смещение даты у помещений
};
